<ng-container *ngIf="visible">
  <div class="main-banner-container">
    <div class="app-banner">
      <div class="app-banner__remove-btn" (click)="close()">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-close"></div>
      </div>
      <div class="image-container image-container--loaded">
        <img rel="preload" alt="Logo" src="assets/custom/image/AppLogo.png" class="image" />
      </div>
      <div class="app-banner-paragraph">
        <span langkey="phOpenLinkInApp_Text"></span>
      </div>
      <div class="app-banner__open-btn" (click)="redirectToApp()" langkey="phOpenLinkInApp_Action_Open"></div>
    </div>
  </div>
</ng-container>